import api from '@/api';

const help = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      instructions: [],
      support: [],
    };
  },

  mutations: {
    setInstruction(state, payload) {
      state.instructions = payload.instructions;
    },
    setSupport(state, payload) {
      state.support = payload.support;
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
  },

  actions: {
    async loadInstruction({ commit, rootState }) {
      commit('changeLoading', true);

      try {
        const { isLoggedIn } = rootState.user;

        if (!isLoggedIn) {
          return;
        }
        const instructions = await api.pub.instruction();
        commit('setInstruction', { instructions });
      } catch (e) {
        console.log(e);
        commit('setInstruction', {});
      } finally {
        commit('changeLoading', false);
      }
    },
    async loadContacts({ commit, rootState }) {
      commit('changeLoading', true);

      try {
        const { isLoggedIn } = rootState.user;

        if (!isLoggedIn) {
          return;
        }
        const support = await api.pub.technicalSupport();
        commit('setSupport', { support });
      } catch (e) {
        console.log(e);
        commit('setSupport', {});
      } finally {
        commit('changeLoading', false);
      }
    },
  },

};

export default help;
